import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnnouncement = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "white",
		d: "M15.3984 0H15.75H16.0312L16.875 0V0.84375V6.32812C17.5078 6.64453 18 7.48828 18 8.4375C18 9.42187 17.5078 10.2656 16.875 10.582V16.0312V16.875H16.0313H15.75H15.3984L15.1523 16.6289L13.6055 15.1172C11.918 13.4297 9.66797 12.4453 7.3125 12.4102L7.3125 16.3125V18H5.625H3.9375H2.25L2.25 16.3125L2.25 12.375H1.6875H0L0 10.6875L0 6.1875L0 4.5H1.6875L5.625 4.5H7.03125C9.49219 4.5 11.8477 3.55078 13.6055 1.79297L15.1523 0.246094L15.3984 0ZM14.8008 13.9219L15.1875 14.3086L15.1875 2.60156L14.8008 2.98828C12.7969 4.99219 10.125 6.11719 7.3125 6.1875V10.6875V10.7227C10.125 10.7578 12.7969 11.918 14.8008 13.9219ZM1.6875 6.1875L1.6875 10.6875H2.25H3.9375L5.625 10.6875L5.625 6.1875L1.6875 6.1875ZM3.9375 12.375L3.9375 16.3125H5.625L5.625 12.375L3.9375 12.375Z"
	})
});
const ForwardRef = forwardRef(SvgAnnouncement);
export default ForwardRef;
